let optiontemp=false;
const newArrayfilter1 = [];
const sectionsProduct1 = document.querySelectorAll(".product_section_1");
document.addEventListener('variant:change', function(evt) {

  let changeTitleVariant = document.querySelector(".changeTitleVariant");
  
  let changeDescVariant = document.querySelector(".product-descritpion .collapsible-content__inner");
  let collapsibleDescButton = document.querySelector(".product-descritpion .collapsible-trigger");
  
  let changeFeaturVariant = document.querySelector(".collapsibles-wrapper[data-titleh='caracteristicas'] .collapsible-content__inner");
  console.log("evt.detail.variant.option1 --1");
  console.log(window.idvar);
  console.log(evt.detail);
  if(evt.detail.variant != null){
    let priceButtonWrapper  = document.querySelector(".priceButtonWrapper");
    if(evt.detail.variant.available){
      priceButtonWrapper.classList.remove("Out_of_Stock");
    }else{
      priceButtonWrapper.classList.add("Out_of_Stock");
    }

    console.log("===============changeTitleVariant===============");
    console.log(changeTitleVariant);
    
    if(Boolean(changeTitleVariant)){
  
      let elementeSet = window.idvar.filter((element) =>{
        if(element.variant_id ==  evt.detail.variant.id){
          return element;
        }
      });

      console.log(elementeSet);
      
      if ( elementeSet.length> 0 && elementeSet[0].variation_title != "" ){
        changeTitleVariant.innerText = elementeSet[0].variation_title;
      }
      /*
      if(window.idvar[evt.detail.variant.id].description!=""){
        changeDescVariant.innerHTML = window.idvar[evt.detail.variant.id].description;
      }
      */
    }
    console.log("evt.detail.variant.option1 --2");
    console.log(evt);
    
    let opt_color = setLowerCase(evt.detail.variant.option1);
    let opt_color2 = setLowerCase(evt.detail.variant.option2);
  
    let newArrayfilter = window.idvar.filter((element) =>{
        if(element.options == opt_color && element.description != "" ){
          return element;
        }
      });
    
    let newArrayfilter2 = window.descriptions.filter((element) =>{
        let color = setLowerCase(element.color);
        let color2 = setLowerCase(opt_color);
        if(color == color2){
          return element;
        }
      });
    
    let newArrayfilter3 = window.descriptions.filter((element) =>{
      let color = setLowerCase(element.color);
      let color2 = setLowerCase(opt_color2);
  
      if(color == color2){
        return element;
      }
    });

    
    if (newArrayfilter2.length> 0){

      changeDescVariant.innerHTML = newArrayfilter2[0].description;
      changeFeaturVariant.innerHTML = newArrayfilter2[0].featured;
      //let clickEvent = new Event('click');
      //collapsibleDescButton.dispatchEvent(clickEvent);
    }else if(newArrayfilter3.length> 0){

      changeDescVariant.innerHTML = newArrayfilter3[0].description;
      changeFeaturVariant.innerHTML = newArrayfilter3[0].featured;
      
      //let clickEvent = new Event('click');
      //collapsibleDescButton.dispatchEvent(clickEvent);
    }
  
    if(Boolean(sectionsProduct1)){
      let allhide = true;
      sectionsProduct1.forEach(section=>{
        section.classList.add("hide");
        let datacolors = section.dataset.colors.split(',');
        if( datacolors.includes(opt_color) ){
          section.classList.remove("hide");
          allhide = false;
        }
      });
  
      if(allhide){
        if(Boolean(sectionsProduct1[0])){
          sectionsProduct1[0].classList.remove("hide");
        }
      }
    }
  }else{
    let priceButtonWrapper = document.querySelector(".priceButtonWrapper");
    priceButtonWrapper.classList.add("Out_of_Stock");
  }
  
});

document.addEventListener("DOMContentLoaded", function() {
  const formPrivacyPolicy = document.querySelector("#formPrivacyPolicy");
  if(Boolean(formPrivacyPolicy)){
    formPrivacyPolicy.addEventListener("input",e=>{
      const buttonContactModal = document.querySelector("#buttonContactModal");
      if(formPrivacyPolicy.checked){
        buttonContactModal.disabled=false;
      }else{
        buttonContactModal.disabled=true;
      }
    });
  }

  if(Boolean(sectionsProduct1)){
    let allhide = true;
    sectionsProduct1.forEach(section=>{
      if( section.classList.contains("hide") ){
		//allhide=false;
      }else{
        allhide=false;
      }
    });
    if(allhide){
      if(Boolean(sectionsProduct1[0])){
      sectionsProduct1[0].classList.remove("hide");
      }
    }
  }
  
  let varianIdSeletected = document.querySelector('textarea[data-current-variant-json]');
  if(Boolean(varianIdSeletected)){
    let changeDescVariant = document.querySelector(".product-descritpion .collapsible-content__inner");
    let changeFeaturVariant = document.querySelector(".collapsibles-wrapper[data-titleh='caracteristicas'] .collapsible-content__inner");
    let variantSelect = JSON.parse(varianIdSeletected.innerHTML);
    console.log("evt.detail.variant.option1******************");
    console.log(variantSelect);


    let opt_color = setLowerCase(variantSelect.option1);
    let opt_color2 = setLowerCase(variantSelect.option2);

    let newArrayfilter = window.idvar.filter((element) =>{
      if(element.options == opt_color && element.description != "" ){
        return element;
      }
    });

    let newArrayfilter2 = window.descriptions.filter((element) =>{
      let color = setLowerCase(element.color);
      let color2 = setLowerCase(opt_color);
      if(color == color2){
        return element;
      }
    });

    let newArrayfilter3 = window.descriptions.filter((element) =>{
      let color = setLowerCase(element.color);
      let color2 = setLowerCase(opt_color2);

      if(color == color2){
        return element;
      }
    });
    
    if (newArrayfilter2.length> 0){
      console.log("newArrayfilter2");
      console.log(newArrayfilter2);
      changeDescVariant.innerHTML = newArrayfilter2[0].description;
      changeFeaturVariant.innerHTML = newArrayfilter2[0].featured;
      //let clickEvent = new Event('click');
      //collapsibleDescButton.dispatchEvent(clickEvent);
    }else if(newArrayfilter3.length> 0){
      console.log("newArrayfilter3");
      console.log(newArrayfilter3);
      changeDescVariant.innerHTML = newArrayfilter3[0].description;
      changeFeaturVariant.innerHTML = newArrayfilter3[0].featured;

      //let clickEvent = new Event('click');
      //collapsibleDescButton.dispatchEvent(clickEvent);
    }

  }

  
  
  
  
});

function setLowerCase(str){
  let res = str.toLowerCase();
  return res;
}


const drawer = new theme.Drawers('FormDrawer', 'contact-modal');
drawer.init();

const btnOpenForm  = document.querySelectorAll(`[href="#cobranding"]`);
btnOpenForm.forEach(btnclick=>{
  btnclick.addEventListener('click', drawer.open.bind(this));
});

/* PAGINA DE TIENDAS */
let current_lang = "";
if (document.documentElement.lang === "en") {
  current_lang = "Select a province";
} else if (document.documentElement.lang === "es") {
  current_lang = "Selecciona una provincia";
}
const listaProvincias = document.querySelector("#provinces");
const itemProvincias = document.querySelectorAll(".itemWraper");

function GetSelectedTextValue(listaProvincias) {
  itemProvincias.forEach(item =>{
    item.classList.remove("hide");
  });      
  var selectedText = listaProvincias.options[listaProvincias.selectedIndex].innerHTML;
  var selectedValue = listaProvincias.value;

  if (selectedText == current_lang){
    itemProvincias.forEach(item =>{
      item.classList.remove("hide");
    });   
  }else{
    itemProvincias.forEach(item =>{
      if (item.dataset.provincia == selectedValue){
        item.classList.remove("hide");
      }else {
        item.classList.add("hide");
      }
    });
  }
}
/* REMOVE ALT FROM MENU ITEMS */
const swatch_colors = document.querySelectorAll('.site-nav__dropdown-link .variant-input-wrap a');
swatch_colors.forEach(color=>{
  color.setAttribute("title", "");
});

const navlinks = document.querySelectorAll('.site-nav__item a svg title');
navlinks.forEach(link=>{
  link.innerHTML=" ";
});

const faqTitles = document.querySelectorAll('.title_faq .index-section.index-section--faq');
const sidebarMenus = document.querySelectorAll('.index-section.index-section--faq .sidebar-text');
const sidebarContainer = document.querySelector('#faq_page_sidebar');

sidebarMenus.forEach((menu, i)=>{
  let newMenu = document.createElement("a");
  newMenu.innerHTML= menu.innerHTML;
  newMenu.setAttribute("data-faq", `title-faq-${i+1}`);
  sidebarContainer.appendChild(newMenu);

});

faqTitles.forEach((faq, i)=>{
  faq.setAttribute("id", `title-faq-${i+1}`);
});

let sidebarLinks = document.querySelectorAll('#faq_page_sidebar a');
sidebarLinks.forEach(link=>{  
  link.addEventListener("click", function(event) {
    let posY = document.querySelector(`#${link.dataset.faq}`).offsetTop;
    console.log(document.querySelector(`#${link.dataset.faq}`));
    //console.log(posY);
    window.scrollTo(0, posY-200);
  });
});
/* CART DRAWER NOTICE */

let free_msg = "";
if (document.documentElement.lang === "en") {
  free_msg = "Congratulations! Your shipping is free";
} else if (document.documentElement.lang === "es") {
  free_msg = "¡Felicidades! Tu envío es gratuito";
}
      let target = document.querySelector('#CartDrawerForm div[data-products]');
      
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          let rem_amount = document.querySelector(".remaining_amount");  
          let subtotal = document.querySelector(".cart__item-sub div[data-subtotal]").innerHTML;  
          let split_subtotal1 = subtotal.split("€");
          let split_subtotal = split_subtotal1[0].replace(",", ".");
  
          if(split_subtotal < 19.00){
            let cal_new_amount = 19.00 - split_subtotal;
            let cal_new_amount_final = cal_new_amount.toFixed(2);
            let converted_amount = cal_new_amount_final.replace(".", ",");
            if (document.documentElement.lang === "en") {
              rem_amount.innerHTML  = `Spend ${converted_amount} euros more and get free shipping`;
            } else if (document.documentElement.lang === "es") {
              rem_amount.innerHTML  = `Te faltan ${converted_amount} euros para que tu envío sea gratuito`;
            }          
            /* Spend  more and get free shipping! */
            /* Te faltan "+ cal_new_amount_final.replace(".", ",") +" euros para que tu envío sea gratuito */
         }else{
            rem_amount.innerHTML  = free_msg;            
          }
        });
      });
      var config = { attributes: true, childList: true, characterData: true };
      observer.observe(target, config); 

/*let rem_amount = document.querySelector(".cart__item-sub .js-qty__num");  
rem_amount.addEventListener('change', event => {
  console.log(rem_amount.value);
});*/

  /*setInterval(function () {
    let rem_amount = document.querySelector(".remaining_amount");  
  let subtotal = document.querySelector(".cart__item-sub div[data-subtotal]").innerHTML;  
    let split_subtotal = subtotal.split("€");
    console.log(subtotal);
    console.log(split_subtotal);
    console.log("result "+split_subtotal[0]);
    let cal_new_amount = 19 - parseFloat(split_subtotal[0]);
    console.log(cal_new_amount);
  rem_amount.innerHTML  = "Te faltan "+cal_new_amount+" euros para que tu envío sea gratuito";
  }, 1000);*/

let array_tabs = document.querySelectorAll(".product-block.product-block--tab");  

        let btn_collapsible = array_tabs[0].querySelector("button.collapsible-trigger");
        let content_collapsible = array_tabs[0].querySelector("div.collapsible-content");

        btn_collapsible.classList.add("is-open");
        btn_collapsible.setAttribute("aria-expanded", "true");
        content_collapsible.classList.add("is-open","first-time");
        content_collapsible.setAttribute("aria-expanded", "true");  

       



